var _desc, _circle, _ellipse, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversedecoderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 220",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "UniverseDecoder logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Coral planet with white code brackets and a light lavender orbital ring, mint and violet satellites.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 110,
    r: 66,
    fill: "#F47763"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 110,
    rx: 102,
    ry: 36,
    transform: "rotate(-31 140 110)",
    fill: "none",
    stroke: "#D7D4FF",
    strokeWidth: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 151,
    r: 16,
    fill: "#58B99A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 59,
    r: 10,
    fill: "#8067D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 85 L118 110 L134 135 M146 85 L162 110 L146 135",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversedecoderLogo);
export default __webpack_public_path__ + "static/media/universedecoder-logo.3278d771bd75f69d0a59b314bc567fd6.svg";
export { ForwardRef as ReactComponent };